import restClient from 'config/httpClient';
import { call, put, takeLatest } from 'redux-saga/effects';

import * as actions from 'modules/app/intl/actions';
import * as actionTypes from 'modules/app/intl/actionTypes';

function* fetchTranslations({ payload }) {
  const { request } = payload;
  try {
    const { data: translations } = yield call(restClient.request, request);
    yield put(actions.fetchTranslationsSuccess(translations));
  } catch (error) {
    yield put(actions.fetchTranslationsFailure(error));
  }
}

export default function* customizeSagas() {
  yield takeLatest([actionTypes.FETCH_TRANSLATIONS], fetchTranslations);
}
